import { c as _c } from "react/compiler-runtime";
import { FULL_PERCENTAGE } from "@/utils/constants";
import { cn } from "@/utils/helpers";
import { useEffect, useRef, useState } from "react";
export interface ProgressBarProps {
  percentage: number;
  className?: string;
  containerClassName?: string;
  fillClassName?: string;
  duration?: number;
  delay?: number;
}
const PROGRESS_BAR_DEFAULT_DURATION = 1500;
const PROGRESS_BAR_DEFAULT_DELAY = 0;
export const ProgressBar = t0 => {
  const $ = _c(18);
  const {
    percentage,
    className,
    containerClassName,
    fillClassName,
    duration: t1,
    delay: t2
  } = t0;
  const duration = t1 === undefined ? PROGRESS_BAR_DEFAULT_DURATION : t1;
  const delay = t2 === undefined ? PROGRESS_BAR_DEFAULT_DELAY : t2;
  const [progress, setProgress] = useState(0);
  const timeoutRef = useRef(null);
  const hasInitialDelayRef = useRef(false);
  let t3;
  let t4;
  if ($[0] !== delay || $[1] !== percentage) {
    t3 = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      const updateProgress = () => {
        setProgress(percentage);
      };
      if (delay > 0 && !hasInitialDelayRef.current) {
        timeoutRef.current = setTimeout(() => {
          updateProgress();
          hasInitialDelayRef.current = true;
        }, delay);
      } else {
        timeoutRef.current = setTimeout(updateProgress, 0);
        if (!hasInitialDelayRef.current) {
          hasInitialDelayRef.current = true;
        }
      }
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    };
    t4 = [percentage, delay];
    $[0] = delay;
    $[1] = percentage;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== className || $[5] !== containerClassName) {
    t5 = cn("h-2 bg-white/10 rounded-full overflow-hidden", className, containerClassName);
    $[4] = className;
    $[5] = containerClassName;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== fillClassName) {
    t6 = cn("h-full w-full bg-(--color-accent-3) rounded-full origin-left", fillClassName);
    $[7] = fillClassName;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = `scaleX(${progress / FULL_PERCENTAGE})`;
  const t8 = `transform ${duration}ms cubic-bezier(0.4, 0, 0.2, 1)`;
  let t9;
  if ($[9] !== t7 || $[10] !== t8) {
    t9 = {
      transform: t7,
      transition: t8
    };
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t6 || $[13] !== t9) {
    t10 = <div className={t6} style={t9} />;
    $[12] = t6;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t5) {
    t11 = <div className={t5}>{t10}</div>;
    $[15] = t10;
    $[16] = t5;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
};